
import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import { ConfigModule } from '@/store/modules/config'
import { CONFIGAPI } from '@/api/config'
import { getuserCurrentApp } from '@/utils/cookies'

@Component({
  name: 'logDialog',
  components: {}
})
export default class extends Vue {
  @Prop({ default: '' }) private type!: string
  private typeOption = {
    group: '群组',
    location: '地区',
    computer_type: '笔记本型号',
    issue_type: '问题类型',
    global_config: '通用配置',
    team_info: '团队信息',
    common_type: '网络工单通用配置信息'
  }

  private tableData = []
  private total = 0 // 总条数
  private currentPage = 1
  private columns = [
    { field: 'username', title: '操作人', width: 110 },
    { field: 'action', title: '操作类型', width: 110 },
    { field: 'resource', title: '操作描述' },
    { field: 'datetime', title: '操作时间', width: 170 }
  ]

  get userCurrentApp() {
    return getuserCurrentApp()
  }

  get dialogVisible() {
    return ConfigModule.configLogDialog
  }

  @Watch('dialogVisible')
  private initForm() {
    if (this.dialogVisible) { // 打开弹框
      this.getTableData()
    }
  }

  getTableData() {
    CONFIGAPI.getConfigLog({
      config_type: this.type,
      page: this.currentPage,
      app_id: this.userCurrentApp
    }).then((res) => {
      if (res.stat === 1) {
        this.tableData = res.data.lists
        this.total = res.data.count
      }
    }).catch((error) => {
      console.log('发生错误！', error)
    })
  }

  private handleCurrentChange(val: number) {
    this.currentPage = val
    this.getTableData()
  }

  // 关闭弹框
  private handleClose() {
    ConfigModule.ToggleDialogStatus({
      name: 'configLogDialog',
      value: false
    })
  }
}
